export const usePortalContainer = () => {
  const portalContainerRef = useRef<HTMLDivElement>(
    document.getElementById('app') as HTMLDivElement
  );
  useEffect(() => {
    portalContainerRef.current = document.getElementById('app') as HTMLDivElement;
  }, []);
  return {
    portalContainerRef,
  };
};
